import { useEffect, useState, useCallback } from "react";
import AdminLayout from "@/components/AdminLayout";
import { api } from "@/lib/api";
import { Card, CardContent } from "@/components/ui/card";
import { Badge } from "@/components/ui/badge";
import { Th, Td, Pagination } from "./AdminUsers";
import { Input } from "@/components/ui/input";
import { Search } from "lucide-react";

export default function AdminAuditLogs() {
  const [rows, setRows] = useState([]);
  const [total, setTotal] = useState(0);
  const [eventType, setEventType] = useState("");
  const [actorId, setActorId] = useState("");
  const [skip, setSkip] = useState(0);
  const limit = 50;

  const load = useCallback(async () => {
    try {
      const { data } = await api.get("/admin/audit-logs", { params: { event_type: eventType, actor_id: actorId, skip, limit } });
      setRows(data.rows);
      setTotal(data.total);
    } catch (e) {}
  }, [eventType, actorId, skip]);
  useEffect(() => { load(); }, [load]);

  return (
    <AdminLayout subtitle="Module 21" title="Audit Logs" actions={<div className="text-xs font-mono-plex text-zinc-500">{total.toLocaleString()} events</div>}>
      <div className="flex flex-wrap gap-3 mb-5" data-testid="audit-filters">
        <div className="relative min-w-[240px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input value={eventType} onChange={(e) => setEventType(e.target.value)} placeholder="event type (e.g. user_suspended)" className="rounded-sm h-9 pl-9 bg-white/5 border-white/10 text-white" data-testid="audit-event-filter" />
        </div>
        <div className="relative min-w-[240px]">
          <Search className="w-4 h-4 absolute left-3 top-1/2 -translate-y-1/2 text-zinc-500" />
          <Input value={actorId} onChange={(e) => setActorId(e.target.value)} placeholder="actor user id" className="rounded-sm h-9 pl-9 bg-white/5 border-white/10 text-white" data-testid="audit-actor-filter" />
        </div>
      </div>

      <Card className="rounded-sm border-white/10 bg-white/[0.02]">
        <CardContent className="p-0 overflow-x-auto">
          <table className="w-full text-sm" data-testid="audit-table">
            <thead className="bg-white/5">
              <tr className="text-left">
                <Th>Timestamp</Th>
                <Th>Event</Th>
                <Th>Actor</Th>
                <Th>Target</Th>
                <Th>Meta</Th>
              </tr>
            </thead>
            <tbody>
              {rows.map((r) => (
                <tr key={r.id} className="border-t border-white/5 hover:bg-white/[0.03] align-top" data-testid={`audit-row-${r.id}`}>
                  <Td className="font-mono-plex text-xs text-zinc-400">{r.timestamp}</Td>
                  <Td><Badge className="bg-ec-emerald/10 text-ec-emerald border-ec-emerald/30 rounded-sm font-mono-plex text-xs">{r.event_type}</Badge></Td>
                  <Td className="font-mono-plex text-[10px] text-zinc-400">{r.actor_id || "—"}</Td>
                  <Td className="font-mono-plex text-[10px] text-zinc-400">{r.target_id || "—"}</Td>
                  <Td className="font-mono-plex text-[10px] text-zinc-500 max-w-[400px] truncate">{JSON.stringify(r.meta || {})}</Td>
                </tr>
              ))}
              {rows.length === 0 && (
                <tr><td colSpan={5} className="p-10 text-center text-zinc-500" data-testid="audit-empty">No events.</td></tr>
              )}
            </tbody>
          </table>
        </CardContent>
      </Card>

      <Pagination total={total} skip={skip} limit={limit} setSkip={setSkip} />
    </AdminLayout>
  );
}
